import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ReactNode } from 'react';
import './index.scss';

type CustomAccordionProps = {
    isExpanded: boolean;
    toggleAccordion: () => void;
    children: [ReactNode, ReactNode];
    customClass?: string;
    expandIcon?: ReactNode;
};

const CustomAccordion: React.FC<CustomAccordionProps> = ({ isExpanded, toggleAccordion, children, customClass = '', expandIcon }) => {
    return (
        <Accordion expanded={isExpanded} disableGutters className={`custom-accordian ${customClass}`}>
            <AccordionSummary
                className={`custom-accordian-summary ${customClass}`}
                expandIcon={expandIcon}
                aria-controls="panel1-content"
                id="panel1-header"
                onClick={toggleAccordion}
            >
                {children[0]} {/* First child as summary */}
            </AccordionSummary>
            <AccordionDetails className={`custom-accordian-details ${customClass}`}>
                {children[1]} {/* Second child as details */}
            </AccordionDetails>
        </Accordion>
    );
};
export default CustomAccordion;